<template>
	<el-drawer class="download-box" title="订单明细导出" :visible.sync="drawerVisible" destroy-on-close show-close :size="800"
		:before-close="handleClose" @close="handleClose">
		<div class="drawer-content">
			<el-radio-group v-model="tabValue">
				<el-radio-button v-for="item in tabList" :label="item.value">{{ item.label }}</el-radio-button>
			</el-radio-group>
			<div v-if="tabValue === 1">
				<download-report :teamType="teamType" :parames="parames" @ok="handleOk" @close="handleClose" />
			</div>
			<div v-if="tabValue === 2">
				<download-record />
			</div>
		</div>
	</el-drawer>
</template>

<script>
import DownloadReport from '@/components/DownloadReport'
import DownloadRecord from '@/components/DownloadRecord'
export default {
	components: {
		DownloadReport,
		DownloadRecord,
	},
	props: {
		isShow: {
			type: Boolean,
			default: false
		},
		parames: {
			type: Object,
			default: () => ({})
		},
		teamType: {
			type: [Number, String],
			default: 1
		},
	},
	computed: {
		drawerVisible: {
			get() {
				return this.isShow
			},
			set(val) {

			}
		},
	},
	data() {
		return {
			tabValue: 1,
			tabList: [
				{
					label: '下载报表',
					value: 1
				},
				{
					label: '下载记录',
					value: 2
				},
			],
		}
	},
	methods: {
		init(){
			this.tabValue = 1
		},
		handleClose() {
			this.$emit('close')
		},
		handleOk(){
			this.tabValue = 2
		}
	}
}
</script>

<style scoped lang="scss">
.download-box {
	::v-deep .el-drawer {
		background-color: #f8f9fa;
	}

	::v-deep .el-drawer__header {
		color: #333;
		font-size: 17px;
		font-weight: bold;
	}

	::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
		background-color: #333;
		border-color: #333;
		box-shadow: -1px 0 0 0 #333;
	}
	::v-deep .el-radio-button__inner:hover {
		color: #606266;
	}
::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner:hover {
	color: #fff;
}
	.drawer-content {
		padding: 0 20px;
	}
}
</style>
